export default __webpack_public_path__ + "static/media/learose-768w.f6a34ce9.png";